import React, { useState } from 'react';
import Button from "./components/Button";
import {Card} from "./components/Cards/Card";
import line from "../../assets/Line 16.png"
import styles from "./catalogSection.module.sass"
import small_line from "../../assets/catalog_line.png"
import man from "../../assets/man_blue_jacket.png"
import bluzka1 from "../../assets/items/Bluzki/bluzka1.jpg"
import bluzka2 from "../../assets/items/Bluzki/bluzka2.jpg"
import bluzka3 from "../../assets/items/Bluzki/bluzka3.jpg"
import bluzka4 from "../../assets/items/Bluzki/bluzka4.jpg"
import bluzka5 from "../../assets/items/Bluzki/bluzka5.jpg"
import bluzka6 from "../../assets/items/Bluzki/bluzka6.jpg"
import shirt1 from "../../assets/items/Shirt/shirt1.jpg"
import shirt2 from "../../assets/items/Shirt/shirt2.jpg"
import shirt3 from "../../assets/items/Shirt/shirt3.jpg"
import shirt4 from "../../assets/items/Shirt/shirt4.jpg"
import shirt5 from "../../assets/items/Shirt/shirt5.jpg"
import shirt6 from "../../assets/items/Shirt/shirt6.jpg"
import jeans1 from "../../assets/items/Jeans/jeans1.jpg"
import jeans2 from "../../assets/items/Jeans/jeans2.jpg"
import jeans3 from "../../assets/items/Jeans/jeans3.jpg"
import jeans4 from "../../assets/items/Jeans/jeans4.jpg"
import jeans5 from "../../assets/items/Jeans/jeans5.jpg"
import jeans6 from "../../assets/items/Jeans/jeans6.jpg"
import dress1 from  "../../assets/items/Dresses/dress1.jpg"
import dress2 from  "../../assets/items/Dresses/dress2.jpg"
import dress3 from  "../../assets/items/Dresses/dress3.jpg"
import dress4 from  "../../assets/items/Dresses/dress4.jpg"
import dress5 from  "../../assets/items/Dresses/dress5.jpg"
import dress6 from  "../../assets/items/Dresses/dress6.jpg"
import tshirt1 from  "../../assets/items/Tshirts/tshirt1.jpg"
import tshirt2 from  "../../assets/items/Tshirts/tshirt2.jpg"
import tshirt3 from  "../../assets/items/Tshirts/tshirt3.jpg"
import tshirt4 from  "../../assets/items/Tshirts/tshirt4.jpg"
import tshirt5 from  "../../assets/items/Tshirts/tshirt5.jpg"
import tshirt6 from  "../../assets/items/Tshirts/tshirt6.jpg"

export const CatalogSection = () => {
    const [active, setActive] = useState("");

    const handleClick = (event : any) => {
        setActive(event.target.id);
        if (window.innerWidth > 801) {
            setTimeout(() => { activeSectionCheck1()}, 1);
        }
        if (window.innerWidth < 801 && window.innerWidth > 460) {
            setTimeout(() => { activeSectionCheck2()}, 1);
        }
        if (window.innerWidth < 461) {
            setTimeout(() => { activeSectionCheck3()}, 1);
        }
    }
    let activeSectionCheck1 = () => {
        let bluzButton = document.getElementById('buttonBLuz') as HTMLButtonElement;
        let bluzButtonClass = bluzButton.className

        let shirtButton = document.getElementById('buttonShirt') as HTMLButtonElement;
        let shirtButtonClass = shirtButton.className

        let jeansButton = document.getElementById('buttonJeans') as HTMLButtonElement;
        let jeansButtonClass = jeansButton.className

        let dressButton = document.getElementById('buttonDress') as HTMLButtonElement;
        let dressButtonClass = dressButton.className

        let tshirtButton = document.getElementById('buttonTshirt') as HTMLButtonElement;
        let tshirtButtonClass = tshirtButton.className

        let sectionBluz = document.getElementById('sectionBluz') as HTMLDivElement;
        let sectionShirt = document.getElementById('sectionShirt') as HTMLDivElement;
        let sectionJeans = document.getElementById('sectionJeans') as HTMLDivElement;
        let sectionDress = document.getElementById('sectionDress') as HTMLDivElement;
        let sectionTshirt = document.getElementById('sectionTshirt') as HTMLDivElement;
        if (bluzButtonClass == 'active') {
            bluzButton.style.background = '#0047FF'
            bluzButton.style.border = '2px solid #0047FF'
            bluzButton.style.color = 'white'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '2px solid black'
            shirtButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '2px solid black'
            jeansButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '2px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '2px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'block'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('bluz active')
        } else if (shirtButtonClass == 'active') {
            shirtButton.style.background = '#0047FF'
            shirtButton.style.border = '2px solid #0047FF'
            shirtButton.style.color = 'white'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '2px solid black'
            bluzButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '2px solid black'
            jeansButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '2px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '2px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'block'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('shirt active')
        } else if (jeansButtonClass == 'active') {
            jeansButton.style.background = '#0047FF'
            jeansButton.style.border = '2px solid #0047FF'
            jeansButton.style.color = 'white'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '2px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '2px solid black'
            bluzButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '2px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '2px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'block'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('jeans active')
        } else if (dressButtonClass == 'active') {
            dressButton.style.background = '#0047FF'
            dressButton.style.border = '2px solid #0047FF'
            dressButton.style.color = 'white'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '2px solid black'
            jeansButton.style.color = 'black'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '2px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '2px solid black'
            bluzButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '2px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'block'
            sectionTshirt.style.display = 'none'
            console.log('dress active')
        } else if (tshirtButtonClass == 'active') {
            tshirtButton.style.background = '#0047FF'
            tshirtButton.style.border = '2px solid #0047FF'
            tshirtButton.style.color = 'white'
            dressButton.style.background = 'white'
            dressButton.style.border = '2px solid black'
            dressButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '2px solid black'
            jeansButton.style.color = 'black'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '2px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '2px solid black'
            bluzButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'block'
            console.log('tshirt active')
        }
    }

    let activeSectionCheck2 = () => {
        let bluzButton = document.getElementById('buttonBLuz1') as HTMLButtonElement;
        let bluzButtonClass = bluzButton.className

        let shirtButton = document.getElementById('buttonShirt1') as HTMLButtonElement;
        let shirtButtonClass = shirtButton.className

        let jeansButton = document.getElementById('buttonJeans1') as HTMLButtonElement;
        let jeansButtonClass = jeansButton.className

        let dressButton = document.getElementById('buttonDress1') as HTMLButtonElement;
        let dressButtonClass = dressButton.className

        let tshirtButton = document.getElementById('buttonTshirt1') as HTMLButtonElement;
        let tshirtButtonClass = tshirtButton.className

        let sectionBluz = document.getElementById('sectionBluz') as HTMLDivElement;
        let sectionShirt = document.getElementById('sectionShirt') as HTMLDivElement;
        let sectionJeans = document.getElementById('sectionJeans') as HTMLDivElement;
        let sectionDress = document.getElementById('sectionDress') as HTMLDivElement;
        let sectionTshirt = document.getElementById('sectionTshirt') as HTMLDivElement;
        if (bluzButtonClass == 'active') {
            bluzButton.style.background = '#0047FF'
            bluzButton.style.border = '2px solid #0047FF'
            bluzButton.style.color = 'white'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '2px solid black'
            shirtButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '2px solid black'
            jeansButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '2px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '2px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'block'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('bluz active')
        } else if (shirtButtonClass == 'active') {
            shirtButton.style.background = '#0047FF'
            shirtButton.style.border = '2px solid #0047FF'
            shirtButton.style.color = 'white'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '2px solid black'
            bluzButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '2px solid black'
            jeansButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '2px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '2px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'block'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('shirt active')
        } else if (jeansButtonClass == 'active') {
            jeansButton.style.background = '#0047FF'
            jeansButton.style.border = '2px solid #0047FF'
            jeansButton.style.color = 'white'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '2px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '2px solid black'
            bluzButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '2px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '2px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'block'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('jeans active')
        } else if (dressButtonClass == 'active') {
            dressButton.style.background = '#0047FF'
            dressButton.style.border = '2px solid #0047FF'
            dressButton.style.color = 'white'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '2px solid black'
            jeansButton.style.color = 'black'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '2px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '2px solid black'
            bluzButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '2px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'block'
            sectionTshirt.style.display = 'none'
            console.log('dress active')
        } else if (tshirtButtonClass == 'active') {
            tshirtButton.style.background = '#0047FF'
            tshirtButton.style.border = '2px solid #0047FF'
            tshirtButton.style.color = 'white'
            dressButton.style.background = 'white'
            dressButton.style.border = '2px solid black'
            dressButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '2px solid black'
            jeansButton.style.color = 'black'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '2px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '2px solid black'
            bluzButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'block'
            console.log('tshirt active')
        }
    }

    let activeSectionCheck3 = () => {
        let bluzButton = document.getElementById('buttonBLuz2') as HTMLButtonElement;
        let bluzButtonClass = bluzButton.className

        let shirtButton = document.getElementById('buttonShirt2') as HTMLButtonElement;
        let shirtButtonClass = shirtButton.className

        let jeansButton = document.getElementById('buttonJeans2') as HTMLButtonElement;
        let jeansButtonClass = jeansButton.className

        let dressButton = document.getElementById('buttonDress2') as HTMLButtonElement;
        let dressButtonClass = dressButton.className

        let tshirtButton = document.getElementById('buttonTshirt2') as HTMLButtonElement;
        let tshirtButtonClass = tshirtButton.className

        let sectionBluz = document.getElementById('sectionBluz') as HTMLDivElement;
        let sectionShirt = document.getElementById('sectionShirt') as HTMLDivElement;
        let sectionJeans = document.getElementById('sectionJeans') as HTMLDivElement;
        let sectionDress = document.getElementById('sectionDress') as HTMLDivElement;
        let sectionTshirt = document.getElementById('sectionTshirt') as HTMLDivElement;
        if (bluzButtonClass == 'active') {
            bluzButton.style.background = '#0047FF'
            bluzButton.style.border = '1px solid #0047FF'
            bluzButton.style.color = 'white'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '1px solid black'
            shirtButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '1px solid black'
            jeansButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '1px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '1px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'block'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('bluz active')
        } else if (shirtButtonClass == 'active') {
            shirtButton.style.background = '#0047FF'
            shirtButton.style.border = '1px solid #0047FF'
            shirtButton.style.color = 'white'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '1px solid black'
            bluzButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '1px solid black'
            jeansButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '1px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '1px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'block'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('shirt active')
        } else if (jeansButtonClass == 'active') {
            jeansButton.style.background = '#0047FF'
            jeansButton.style.border = '1px solid #0047FF'
            jeansButton.style.color = 'white'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '1px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '1px solid black'
            bluzButton.style.color = 'black'
            dressButton.style.background = 'white'
            dressButton.style.border = '1px solid black'
            dressButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '1px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'block'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'none'
            console.log('jeans active')
        } else if (dressButtonClass == 'active') {
            dressButton.style.background = '#0047FF'
            dressButton.style.border = '1px solid #0047FF'
            dressButton.style.color = 'white'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '1px solid black'
            jeansButton.style.color = 'black'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '1px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '1px solid black'
            bluzButton.style.color = 'black'
            tshirtButton.style.background = 'white'
            tshirtButton.style.border = '1px solid black'
            tshirtButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'block'
            sectionTshirt.style.display = 'none'
            console.log('dress active')
        } else if (tshirtButtonClass == 'active') {
            tshirtButton.style.background = '#0047FF'
            tshirtButton.style.border = '1px solid #0047FF'
            tshirtButton.style.color = 'white'
            dressButton.style.background = 'white'
            dressButton.style.border = '1px solid black'
            dressButton.style.color = 'black'
            jeansButton.style.background = 'white'
            jeansButton.style.border = '1px solid black'
            jeansButton.style.color = 'black'
            shirtButton.style.background = 'white'
            shirtButton.style.border = '1px solid black'
            shirtButton.style.color = 'black'
            bluzButton.style.background = 'white'
            bluzButton.style.border = '1px solid black'
            bluzButton.style.color = 'black'
            sectionBluz.style.display = 'none'
            sectionShirt.style.display = 'none'
            sectionJeans.style.display = 'none'
            sectionDress.style.display = 'none'
            sectionTshirt.style.display = 'block'
            console.log('tshirt active')
        }
    }


    return (
        <div className={styles.section__catalog__wrap} id='sectionCatalog'>
            <div className={styles.section__catalog}>
                <div>
                    <span className={styles.section__catalog__header}>Популярные товары</span>
                    <img className={styles.section__catalog__line} src={line} alt=""/>
                    <div className={styles.section__catalog__buttonRow}>
                        <button id='buttonBLuz'
                                onClick={handleClick}
                                className={active === "buttonBLuz" ? "active" : undefined}>
                                Блузы
                        </button>
                        <button id='buttonShirt'
                                onClick={handleClick}
                                className={active === "buttonShirt" ? "active" : undefined}>
                                Рубашки
                        </button>
                        <button id='buttonJeans'
                                onClick={handleClick}
                                className={active === "buttonJeans" ? "active" : undefined}>
                                Джинсы
                        </button>
                        <button id='buttonDress'
                                onClick={handleClick}
                                className={active === "buttonDress" ? "active" : undefined}>
                                Платья
                        </button>
                        <button id='buttonTshirt'
                                onClick={handleClick}
                                className={active === "buttonTshirt" ? "active" : undefined}>
                                Футболки
                        </button>
                    </div>
                    <div className={styles.section__catalog__buttonRowHiddenWrap}>
                        <div className={styles.section__catalog__buttonRowHidden1}>
                            <button id='buttonBLuz1'
                                    onClick={handleClick}
                                    className={active === "buttonBLuz1" ? "active" : undefined}>
                                    Блузы
                            </button>
                            <button id='buttonShirt1'
                                    onClick={handleClick}
                                    className={active === "buttonShirt1" ? "active" : undefined}>
                                    Рубашки
                            </button>
                            <button id='buttonJeans1'
                                    onClick={handleClick}
                                    className={active === "buttonJeans1" ? "active" : undefined}>
                                    Джинсы
                            </button>
                            <button id='buttonDress1'
                                    onClick={handleClick}
                                    className={active === "buttonDress1" ? "active" : undefined}>
                                    Платья
                            </button>
                        </div>
                        <div className={styles.section__catalog__buttonRowHidden2}>
                            <button id='buttonTshirt1'
                                    onClick={handleClick}
                                    className={active === "buttonTshirt1" ? "active" : undefined}>
                                    Футболки
                            </button>
                        </div>
                    </div>
                    <div className={styles.section__catalog__buttonRowHiddenWrap2}>
                        <div className={styles.section__catalog__buttonRowHidden1}>
                            <button id='buttonBLuz2'
                                    onClick={handleClick}
                                    className={active === "buttonBLuz2" ? "active" : undefined}>
                                    Блузы
                            </button>
                            <button id='buttonShirt2'
                                    onClick={handleClick}
                                    className={active === "buttonShirt2" ? "active" : undefined}>
                                    Рубашки
                            </button>
                            <button id='buttonJeans2'
                                    onClick={handleClick}
                                    className={active === "buttonJeans2" ? "active" : undefined}>
                                    Джинсы
                            </button>
                        </div>
                        <div className={styles.section__catalog__buttonRowHidden2}>
                            <button id='buttonDress2'
                                    onClick={handleClick}
                                    className={active === "buttonDress2" ? "active" : undefined}>
                                    Платья
                            </button>
                            <button id='buttonTshirt2'
                                    onClick={handleClick}
                                    className={active === "buttonTshirt2" ? "active" : undefined}>
                                    Футболки
                            </button>
                        </div>
                    </div>
                    <div className={styles.section__catalog__buttonBlock}>
                        <button className={styles.section__catalog__buttonRedirect} >
                            <a className={styles.section__catalog__buttonRedirectText}
                               href="https://vk.com/market-106019478?screen=group"
                               target="_blank"
                            >ОТКРЫТЬ ПОЛНЫЙ КАТАЛОГ</a>
                        </button>
                        <div className={styles.section__catalog__textBlock}>
                            <span className={styles.section__catalog__textRight}>
                               Это лишь малая часть товаров <br/> которая представлена в наших магазинах
                            </span>
                            <img className={styles.section__catalog__imgSmallLine} src={small_line} alt=""/>
                        </div>
                    </div>
                    <div id='sectionBluz' className={styles.section__catalog__items1}>
                        <div className={styles.section__catalog__items}>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_8063767' img={bluzka1} name={"4500 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057368' img={bluzka2} name={"5990 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057353' img={bluzka3} name={"2900 рублей"} price={"52-80"}></Card>
                            </div>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_7825748' img={bluzka4} name={"3990 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8063842' img={bluzka5} name={"4500 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057351' img={bluzka6} name={"2700 рублей"} price={"52-80"}></Card>
                            </div>
                        </div>
                    </div>
                    <div id='sectionShirt' className={styles.section__catalog__items2}>
                        <div className={styles.section__catalog__items}>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_7817591' img={shirt1} name={"4500 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7817572' img={shirt2} name={"2900 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7051833' img={shirt3} name={"2900 рублей"} price={"52-80"}></Card>
                            </div>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_7811918' img={shirt4} name={"5490 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7051826' img={shirt5} name={"4790 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7051831' img={shirt6} name={"4290 рублей"} price={"52-80"}></Card>
                            </div>
                        </div>
                    </div>
                    <div id='sectionJeans' className={styles.section__catalog__items3}>
                        <div className={styles.section__catalog__items}>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_7104078' img={jeans1} name={"3290 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7097994' img={jeans2} name={"4900 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7098005' img={jeans3} name={"2690 рублей"} price={"52-80"}></Card>
                            </div>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_7126157' img={jeans4} name={"6900 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057391' img={jeans5} name={"7990 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057419' img={jeans6} name={"3700 рублей"} price={"52-80"}></Card>
                            </div>
                        </div>
                    </div>
                    <div id='sectionDress' className={styles.section__catalog__items4}>
                        <div className={styles.section__catalog__items}>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_8063738' img={dress1} name={"4990 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057414' img={dress2} name={"5590 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057381' img={dress3} name={"5490 рублей"} price={"52-80"}></Card>
                            </div>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_7103722' img={dress4} name={"5890 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7119750' img={dress5} name={"5124 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7103850' img={dress6} name={"3890 рублей"} price={"52-80"}></Card>
                            </div>
                        </div>
                    </div>
                    <div id='sectionTshirt' className={styles.section__catalog__items5}>
                        <div className={styles.section__catalog__items}>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_8057409' img={tshirt1} name={"2290 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057405' img={tshirt2} name={"4200 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057398' img={tshirt3} name={"2990 рублей"} price={"52-80"}></Card>
                            </div>
                            <div className={styles.section__catalog__itemsRow}>
                                <Card href='https://vk.com/market-106019478_8057373' img={tshirt4} name={"2500 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_8057362' img={tshirt5} name={"2590 рублей"} price={"52-80"}></Card>
                                <Card href='https://vk.com/market-106019478_7827041' img={tshirt6} name={"2890 рублей"} price={"52-80"}></Card>
                            </div>
                        </div>
                    </div>
                    <div className={styles.section__catalog__textBlock2}>
                        <img className={styles.section__catalog__imgSmallLine2} src={small_line} alt=""/>
                        <span className={styles.section__catalog__textLeft}>
                         Весь ассортимент вы можете посмотреть <br/> в наших магазинах или связавшись с нами
                     </span>
                    </div>
                </div>
            </div>
        </div>
    );
};